@if(removeComma) {
<span [hidden]="!displayAmount"> {{ amount | number: "1.2-2" | noComma }}</span>
} @else {
<span [hidden]="!displayAmount"> {{ amount | number: "1.2-2" }}</span>
}

<em triggers="mouseenter:mouseleave" container="body"></em>

<ng-template #htmlContent>
    <div>
        <p>
            {{ buttonTooltip | translate }}
        </p>
    </div>
</ng-template>